import React, {useState, useEffect} from "react";
import {useSearchParams} from "react-router-dom";
import {useVsiAppContext} from "../../../../stores/VsiApp";
import {Row, Col, Card} from "reactstrap";
import {VsiBubble, VsiH4} from "../../../../styled/App.styled";
import {spaceDiskTypeDefs} from "../../../../utils/gridColumnDefs/storage/allUnits";
import PieChart from "../../../../components/PieChart";
import BarChart from "../../../../components/BarChart";
import Grid from "../../../../components/Grid";
import {useDataWithRoute, useTitleFromComponent} from "../../../../utils/hooks";

export default function FreeSpaceByDiskByType({title}) {
    const [searchParams] = useSearchParams();
    const [spaceDiskTypeData, setSpaceDiskTypeData] = useState([]);
    const [devices, setDevices] = useState([]);
    const [pieInfo, setPieInfo] = useState([]);
    const categories = ['SAS', 'SSD', 'SATA', 'Unknown', 'Fibre'];
    const [chartSeries, setChartSeries] = useState([]);
    const [scrollHeight, setScrollHeight] = useState();

    const { theme, client, periodId } = useVsiAppContext();


    useTitleFromComponent(`${searchParams.get('device_name')} / ${title}`);

    const [data, { isLoading }] = useDataWithRoute(`/api/v6/report/device_free_space_by_disk_group_proc?client_id=${client.clientId}&period_id=${periodId}&device_name=${encodeURI(searchParams.get('device_name'))}`);

    const getBarGraph = function (dataGrid) {

        // Loop to get the info needed for bar graph
        let dataArray = [];

        for (let i = 0; i < dataGrid.length; i++) {
            let graphInfo = (({
                free_space_sas,
                free_space_ssd,
                free_space_sata,
                free_space_unknown,
                free_space_fibre
            }) => ({
                free_space_sas,
                free_space_ssd,
                free_space_sata,
                free_space_unknown,
                free_space_fibre
            }))(dataGrid[i]);
            dataArray.push(graphInfo);
        }

        let finalArray = []; // For reorganized objects

        for (let y = 0; y < categories.length; y++) {
            // Array of objects > array of arrays
            let smallerArrays = [];
            for (let i = 0; i < dataArray.length; i++) {
                var values = Object.values(dataArray[i]);

                smallerArrays.push(values)
            }

            // Return just values by category
            var removedKeys = [];
            for (let i = 0; i < smallerArrays.length; i++) {
                var newArray = smallerArrays[i].map(data => {
                    return data
                });
                removedKeys.push(newArray[y]);
            }
            finalArray.push(removedKeys);
        }

        let chartInfo = [];
        for (let i = 0; i < categories.length; i++) {
            chartInfo.push({
                name: categories[i],
                data: finalArray[i]
            });
        }

        setChartSeries(chartInfo);
    };

    const getPieChart = function (dataGrid) {
        let pieDataArray = [];

        for (let i = 0; i < dataGrid.length; i++) {
            let graphInfo = (({free_space_total}) => (free_space_total))(dataGrid[i]);
            pieDataArray.push(graphInfo);
        }

        let pieData = [];
        let pieDevices = dataGrid.map(device => {
            return device.disk_group_name
        });

        for (let i = 0; i < pieDevices.length; i++) {
            pieData.push({
                name: pieDevices[i] ? pieDevices[i] : "Unnamed",
                y: pieDataArray[i]
            });
        }

        setPieInfo([{
            name: '',
            data: pieData
        }]);
    };

    const getSpaceDiskType = function (data) {
        setDevices(data.map(device => {
            return device.disk_group_name
        }));

        if (data.length > 15) {
            setScrollHeight(3500)
        } else {
            setScrollHeight(0)
        }

        getBarGraph(data);
        getPieChart(data);
    };

    useEffect(() => {
        setSpaceDiskTypeData(data?.recordset || []);
        getSpaceDiskType(data?.recordset || []);
    }, [data, searchParams]);

    const filterChanged = (eventData) => {
        let filteredData = [];
        eventData.api.forEachNodeAfterFilter(node => {
            if(node.data) filteredData.push(node.data);
        });

        getSpaceDiskType(filteredData);
    };

    return <Card className={`report-card p-2 nav-card-${theme}`}>
        <VsiH4>Free Space by Disk Group by Type - {searchParams.get('device_name')}</VsiH4>
        <Row>
            <Col className="col-6">
                <VsiBubble>
                    <PieChart
                        height={675}
                        series={pieInfo}
                        includeLegend={true}
                    />
                </VsiBubble>
            </Col>
            <Col className="col-6">
                <VsiBubble>
                    <BarChart
                        categories={devices}
                        height={675}
                        series={chartSeries}
                        includeLegend={true}
                        changeAxisTitle={true}
                        scrollHeight={scrollHeight}
                    />
                </VsiBubble>
            </Col>
        </Row>
        <VsiBubble>
            <Grid data={spaceDiskTypeData} columnDefs={spaceDiskTypeDefs} isLoading={isLoading} filterChanged={filterChanged}/>
        </VsiBubble>

    </Card>
}
